import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { DxPopupComponent } from 'devextreme-angular';
import { enumSaleItemType, SaleItem } from '../../model/SaleItem';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import { TransactionService } from 'src/app/services/transaction.service';
import { take } from 'rxjs/operators';
import { ConstantsService } from 'src/app/services/constants.service';

@Component({
  selector: 'app-voucher-code',
  templateUrl: './voucher-code.component.html',
  styleUrls: ['./voucher-code.component.css']
})
export class VoucherCodeComponent {
  @Output() CloseDlg: EventEmitter<{ Action: string, saleItem: SaleItem }> = new EventEmitter<{ Action: string, saleItem: SaleItem }>();

  @ViewChild(DxPopupComponent) popup: DxPopupComponent;
  @ViewChild(DxFormComponent) form: DxFormComponent;

  static btnOKCtrl = null;
  OkButtonOptions = {
    name: 'btnOKVoucher',
    text: 'OK',
    disabled: true,
    onClick: this.btnOk.bind(this),
    onInitialized: function (e) {
      VoucherCodeComponent.btnOKCtrl = e.component;
    }.bind(this),
  };

  CancelButtonOptions = {
    text: 'Cancel',
    onClick: this.btnCancel.bind(this)
  };

  PriceEditorOptions = { min: 0, max: 999.99, format: '£#,##0.00', disabled: true };

  public saleItemDetail: SaleItem = new SaleItem();

  voucherCodeAsyncValidationRule: any;

  constructor(private transactionService: TransactionService, public Constants: ConstantsService) {
    this.show = this.show.bind(this);
    this.VoucherCodeValidation = this.VoucherCodeValidation.bind(this);
    this.EnableOKButton = this.EnableOKButton.bind(this);
    this.onFieldDataChanged = this.onFieldDataChanged.bind(this);
  }

  saleItems: SaleItem[] = [];
  public show(SelectedSaleItem: SaleItem, saleItems: SaleItem[]) {
    this.popup.visible = true;
    this.saleItems = saleItems;
    this.saleItemDetail = SelectedSaleItem; 
    this.form.instance.resetValues();
  }

  btnOk(e) {    
    this.saleItemDetail.IsVoucher=true;  
    this.CloseEditor("UPDATE");
  }

  btnCancel(e) {
    this.CloseEditor("CANCEL");
  }

  CloseEditor(action: string) {
    this.CloseDlg.emit({ Action: action, saleItem: this.saleItemDetail });
    this.popup.visible = false;
  }

  VoucherCodeEditorOptions = {
    name: 'txtVoucherCode',
    maxLength: 50,
    mode: 'Text',
    placeholder:
      'Enter voucher code - Numbers, uppercase letters, and dashes only. It must be between 5 and 50 characters long.',
  };

  VoucherCodeValidation(params): Promise<boolean> {
    return new Promise((resolve) => {
      var items = this.saleItems.filter(
        (i) =>
          i.SaleItemType == enumSaleItemType.Voucher &&
          i.VoucherCode == params.value &&
          i.SaleItemId !== this.saleItemDetail.SaleItemId
      );
      if (items.length > 0) {
        resolve(false);
      } else {
        this.transactionService
          .ValidateNewVoucherCode(params.value)
          .pipe(take(1))
          .subscribe((result: any) => {
            if (result) {
              resolve(result == 1 ? true : false);
            }
          });
      }
    });
  }

  EnableOKButton(enable) {
    if (VoucherCodeComponent.btnOKCtrl)
      VoucherCodeComponent.btnOKCtrl.option('disabled', !enable);
  }

  onFieldDataChanged(e) {
    if (!this.form)
      return;

    if (e?.dataField === 'VoucherCode') {
      const items: any[] = this.form.instance.option('items');

      if (!e?.value) {
        // Remove async validation rule if no value for Voucher Code
        if (!this.voucherCodeAsyncValidationRule) {
          const voucherCode: any = items.find((i) => i?.dataField === 'VoucherCode');
          this.voucherCodeAsyncValidationRule = voucherCode?.validationRules?.find((i) => i?.type === 'async');
        }

        items.forEach((i) => {
          if (i?.dataField === 'VoucherCode') {
            i.validationRules = i?.validationRules?.filter((i: any) => i?.type !== 'async');
          }
        });
      } else {
        // Add async validation rule if value for Voucher Code
        const voucherCode: any = items.find((i) => i?.dataField === 'VoucherCode');
        if (voucherCode?.validationRules?.findIndex((i: any) => i?.type === 'async') === -1) {
          items.forEach((i) => {
            if (i?.dataField === 'VoucherCode') {
              i.validationRules.push(this.voucherCodeAsyncValidationRule);
            }
          });
        }
      }

      this.form.instance.option('items', items);
    }

    this.EnableOKButton(false);
    var v = this.form.instance.validate();

    // If validation is pending because of API call, then we use complete promise to set the UI once API call completed and in the mean time set OK to disabled
    if (v.status == 'pending') {
      v.complete.then((rc) => {
        this.EnableOKButton(rc.isValid);
      });
    } else {
      this.EnableOKButton(v.isValid);
    }
  }
}
